export const TABLE_COLUMN_RESIZE = "table.column.resize";
export const TABLE_COLUMN_RESIZE_END = "table.column.resize.end";
